// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".calendar-wrapper[data-v-1d15e713]{margin:0;padding:0!important;position:relative}.has-text-info[data-v-1d15e713]{color:#3273dc;cursor:pointer}.calendar[data-v-1d15e713]{position:absolute;z-index:999;top:100%;left:0}.field[data-v-1d15e713]{padding:.5rem 1rem;width:100%}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
